export { default as Privacy } from './Privacy'
